export const defaultDropdownSelectedText = "--Select--"

export const defaultSelect = { id: 0, value: "--Select--" }
